<template>
  <div class="ficheVIsioVente">
    <!-- registerApiRtc : {{registerApiRtc}} <br> -->
    <!-- agentOnline : {{agentOnline}} <br>
    loading : {{loading}} <br>
    datasVisiteur.socketID : {{datasVisiteur.socketID}} <br> 
    checkSessionVisioVente :  {{checkSessionVisioVente}}
    timeoutVisioVente : {{timeoutVisioVente}}
    checkClientVisioVente : {{ checkClientVisioVente}}
    -->
    <div class="text-xs-center">

      <v-btn
        v-if="!checkSessionVisioVente && !timeoutVisioVente"
        :loading="loading"
        :disabled="loading || !agentOnline || !datasVisiteur.socketID || !checkClientVisioVente"
        color="success"
        @click.native="askVisioVente()"
      >
        Démarrez la visio vente.
      </v-btn>
      <v-btn
        v-else-if="!checkSessionVisioVente && timeoutVisioVente"
        color="error"
        @click.native="askVisioVente()"
      >
         Reload
      </v-btn>
      <v-btn
        v-else-if="checkSessionVisioVente && timeoutVisioVente"
        color="error"
        @click.native="stopVisioVente(datasVisiteur.visiteurID)"
      >
         Reload
      </v-btn>
      <v-btn
        v-else-if="checkSessionVisioVente && !timeoutVisioVente && !checkRemoteStream"
        color="success"
        @click.native="reAskVisioVente()"
      >
        Renvoyer une invitation
      </v-btn>
      <!-- bouton stop visioconf -->
      <v-btn
        v-if="checkSessionVisioVente && !timeoutVisioVente"
        color="error"
        @click.native="stopVisioVente(datasVisiteur.visiteurID)"
      >
         Arretez la visio vente
      </v-btn>
    </div>

    <v-layout
      id="visioVente-layout"
        column
        align-center
        justify-center
    >

      <div id="container">
          
          <div id="conference">
              <div v-if="!activeConnexionPeer">
              <v-alert
                  :value="true"
                  :color="infosVisioVente.message.color"
                  :icon="infosVisioVente.message.icone"
                  outline
              >
                  {{infosVisioVente.message.text}}
              </v-alert>
              </div>
          </div>
      </div>
    </v-layout>

<!-- 
{{infosVisioVente}}  -->

    <!-- catalogue produits -->
    <wz-catalogue-produits
      @pushproduct="msg => $emit('pushproduct', msg)"
    >
    </wz-catalogue-produits>

  </div>
</template>

<script>
import _watcheebox from '../watcheebox/watcheebox.js'
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
    datasVisiteur: {
      type: Object
    }
  },
  data () {
    return {
      loading: false,
      activeConnexionPeer: false,
      demandeEnvoyee: false,
      timeoutVisioVente: false
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName']),
    ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
    ...mapState('_StoreWatcheeBox', ['status', 'sessionVisioVente']),
    /**
     * Vérifie si la remotestream est bien la (visiteur en visioconf)
     */
    checkRemoteStream () {
      // si il y a une visio en cours
      if (this.sessionVisioVente.sessionId) {
        // console.log('bien en conf avec ce visteur', this.sessionVisioVente)
        // si c'est bien avec ce visiteur
        if (this.sessionVisioVente.visiteurID === this.datasVisiteur.visiteurID) {
          if (this.sessionVisioVente.remoteStream) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },
    /**
     * Vérifie si il y a deja une conf en cours
     */
    checkSessionVisioVente () {
      // si il y a une visio en cours
      if (this.sessionVisioVente.sessionId) {
        // console.log('bien en conf avec ce visteur', this.sessionVisioVente)
        // si c'est bien avec ce visiteur
        if (this.sessionVisioVente.visiteurID === this.datasVisiteur.visiteurID) {
          this.loading = false
          return true
        }
      } else {
        return false
      }
    },
    /**
     * Vérifie avec qui l'agent est en visioconf
     */
    checkClientVisioVente () {
      // si il y a une visio en cours
      if (this.sessionVisioVente.sessionId) {
        // console.log('bien en conf avec ce visteur', this.sessionVisioVente)
        // si c'est bien avec ce visiteur
        if (this.sessionVisioVente.visiteurID !== this.datasVisiteur.visiteurID) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    infosVisioVente () {
      if (this.sessionVisioVente.placePupitreVisio === this.placeVisioPupitre) {
        console.log('infosVisiovente : ', this.sessionVisioVente.message)
        if (this.sessionVisioVente.message.color === 'error') {
          if (this.sessionVisioVente.message.text === 'timeout') {
            this.timeoutVisioVente = true
          }
          if (this.sessionVisioVente.message.text.stack) {
            this.timeoutVisioVente = true
          }
        }
        if (!this.datasVisiteur.socketID) {
          this.timeoutVisioVente = false
          return { message: {
            text: 'Impossible d\'envoyer une invitation car l\'internaute n\'est plus en ligne.',
            color: 'info',
            icone: 'info'
          }}
        } else if (!this.agentOnline) {
          this.timeoutVisioVente = false
          return { message: {
            text: 'Vous devez être en ligne pour pouvoir envoyer une invitation.',
            color: 'info',
            icone: 'info'
          }}
        } else {
          return this.sessionVisioVente
        }
      } else {
        if (this.sessionVisioVente.sessionId) {
          console.log('bien en conf avec ce visteur', this.sessionVisioVente)
          // si c'est bien avec ce visiteur
          if (this.sessionVisioVente.visiteurID !== this.datasVisiteur.visiteurID) {
            this.timeoutVisioVente = false
            return { message: {
              text: 'Impossible d\'envoyer une invitation car vous êtes déjà en visio vente avec un autre internaute.',
              color: 'info',
              icone: 'info'
            }}
          } else {
            // return true
          }
        } else {
          if (!this.datasVisiteur.socketID) {
            this.timeoutVisioVente = false
            return { message: {
              text: 'Impossible d\'envoyer une invitation car l\'internaute n\'est plus en ligne.',
              color: 'info',
              icone: 'info'
            }}
          } else if (!this.agentOnline) {
            this.timeoutVisioVente = false
            return { message: {
              text: 'Vous devez être en ligne pour pouvoir envoyer une invitation.',
              color: 'info',
              icone: 'info'
            }}
          } else {
            this.timeoutVisioVente = false
            return { message: {
              text: 'Vous pouvez envoyer une invitation à votre internaute afin qu\'il puisse participer à votre visio vente.',
              color: 'info',
              icone: 'info'
            }}
          }
        }
      }
    },

    /**
     * Vérifie si l'agent est en ligne
     */
    agentOnline () {
      if (this.$store.state._StoreWatcheeBox.status === 'online' || this.$store.state._StoreWatcheeBox.status === 'busy') {
        if (!this.$store.state._StoreWatcheeBox.sessionVisioconf.confURL) {
          return true
        }
      }
      return false
    },
    // affiche la placePupitre ou '0' si sur la page visitors
    placeVisioPupitre () {
      // mais si c'est sur la page visitors, il n'y a pas de place pupitre
      if (this.$route.fullPath === '/trafic/visitors') {
        return 0
      } else {
        return this.datasVisiteur.placePupitre
      }
    }
  },

  created () {
    // this.closeDialogBox()
  },
  mounted () {},
  beforeDestroy () {},

  methods: {

    // -------------------------------------------
    // envois une invitation à l'internaute
    // -------------------------------------------
    askVisioVente () {
      this.loading = true
      this.timeoutVisioVente = false
      let agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      console.log('this.WATCHEEBOX_STATE.mySocketID', this.WATCHEEBOX_STATE.mySocketID)
      let message = 'Voulez-vous participer à une visio avec moi ?<br>'
      if (this.$store.state._User.entKey === '33673d04d989bd7fa98131b9602c03e5') {
        /* exception ketb kaufman */
        message = 'Acceptez-vous de participer à une visio ou un audio avec moi ?<br>'
      }
      message += '<button type="button" class="tf_btnReponseVisioVente v-btn v-btn--round theme--dark primary" onclick="requestVisioVente(\'yes\')"><div class="v-btn__content">Oui</div></button>'
      message += '<button type="button" class="tf_btnReponseVisioVente v-btn v-btn--round theme--dark primary" onclick="requestVisioVente(\'no\')"><div class="v-btn__content">Non</div></button>'
      // envois du message de demande de sreensharing
      _watcheebox.envoisMessage({
        // 'socket': this.$socket,
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: message,
        attachments: '',
        messageType: 1,
        agentName: unescape(this.fullName)
      })
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: 'Demande envoyée',
        context: 'success'
      })
      this.demandeEnvoyee = true
      this.startVisioVente()
    },
    reAskVisioVente () {
      let agentSocketID = this.WATCHEEBOX_STATE.mySocketID
      console.log('this.WATCHEEBOX_STATE.mySocketID', this.WATCHEEBOX_STATE.mySocketID)
      let message = 'Voulez-vous participer à une visio avec moi ?<br>'
      if (this.$store.state._User.entKey === '33673d04d989bd7fa98131b9602c03e5') {
        /* exception ketb kaufman */
        message = 'Acceptez-vous de participer à une visio ou un audio avec moi ?<br>'
      }
      message += '<button type="button" class="tf_btnReponseVisioVente v-btn v-btn--round theme--dark primary" onclick="requestVisioVente(\'yes\')"><div class="v-btn__content">Oui</div></button>'
      message += '<button type="button" class="tf_btnReponseVisioVente v-btn v-btn--round theme--dark primary" onclick="requestVisioVente(\'no\')"><div class="v-btn__content">Non</div></button>'
      // envois du message de demande de sreensharing
      _watcheebox.envoisMessage({
        // 'socket': this.$socket,
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: message,
        attachments: '',
        messageType: 1,
        agentName: unescape(this.fullName)
      })
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: 'Demande ré-envoyée',
        context: 'success'
      })
      this.demandeEnvoyee = true
    },
    // -------------------------------------------
    // demarre la visiovente
    // -------------------------------------------
    startVisioVente () {
      console.log('startVisioVente - datavisiteur', this.datasVisiteur)
      // ca c'est pour le pupitre
      let dataChange = {
        name: 'startConf',
        value: true,
        placePupitreVisio: this.placeVisioPupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },
    // -------------------------------------------
    // arreter la visiovente
    // -------------------------------------------
    stopVisioVente (sessionId) {
      console.log('stopVisioVente', sessionId)
      let dataChange = {
        name: 'leaveConf',
        value: true,
        placePupitreVisio: this.placeVisioPupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    },
    // -------------------------------------------
    // ferme dialogBox au chargement du composent
    // -------------------------------------------
    closeDialogBox () {
      console.log('closeDialogBox datasVisiteur :', this.datasVisiteur)
      console.log('closeDialogBox sessionVisioVente :', this.sessionVisioVente)
      let dataChange = {
        name: 'leaveConf',
        value: false,
        placePupitreVisio: this.placeVisioPupitre,
        visiteurID: this.datasVisiteur.visiteurID
      }
      this.$store.commit('_StoreWatcheeBox/CHANGE_SESSION_VISIOVENTE', dataChange)
    }
  }
}
</script>

<style>
.ficheVIsioVente  {
  width: calc(100% - 26px);
  margin-left: 6px;
}
.ficheVIsioVente .v-text-field.v-text-field--enclosed .v-text-field__details,
.ficheVIsioVente .v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot {
  padding: 0 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzVisioVente.vue